module.exports = __webpack_public_path__ + "images/banners/category_estimate/banner_category_bulk_482_be4ba57cdec02caf00af7dfc6a6e5ade.png";